import { render, staticRenderFns } from "./end2.vue?vue&type=template&id=718c9771&scoped=true"
import script from "./end2.vue?vue&type=script&lang=js"
export * from "./end2.vue?vue&type=script&lang=js"
import style0 from "./end2.vue?vue&type=style&index=0&id=718c9771&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718c9771",
  null
  
)

export default component.exports